<div class="error-content">
    <img alt="Error" class="img-fluid" src="/assets/img/error-crying.webp">
    <h1>Error 404</h1>
    <h3>Tato stránka nebola naledzená.</h3>
</div>